import { useState, useEffect, useCallback } from 'react';
import { fetchShipmentTeams } from '../apis/shipment';
import type {
  ApiResponse,
  ShipmentTeam,
  ShipmentTeamsResponse,
} from '../apis/types';
import useUnauthorize from './useUnauthorize';
import { useToken } from '../common/helper';

interface UseFetchShipmnetTeamsReturn {
  shipmentTeams: ShipmentTeam[];
  refetchShipmentTeams: () => void;
}

const useFetchShipmentTeams = (
  shipmentId: string
): UseFetchShipmnetTeamsReturn => {
  const { checkTokenExpiry } = useToken();
  const { unauthorize } = useUnauthorize();

  const [shipmentTeams, setShipmentTeams] = useState<ShipmentTeam[]>([]);

  const GetShipmentTeams = useCallback(() => {
    if (!shipmentId) {
      return;
    }
    const token = checkTokenExpiry();
    if (!token) {
      return;
    }
    fetchShipmentTeams(token, shipmentId)
      .then((res: ApiResponse) => {
        const data = res?.data?.data;
        if (data?.is_success && data?.data) {
          const response = res as ShipmentTeamsResponse;
          const teams = response?.data?.data?.data?.common_teams ?? [];
          setShipmentTeams(teams);
        } else {
          setShipmentTeams([]);
        }
      })
      .catch((error) => {
        unauthorize(error);
        setShipmentTeams([]);
      });
  }, [checkTokenExpiry, unauthorize, shipmentId]);

  useEffect(() => {
    GetShipmentTeams();
  }, [GetShipmentTeams]);

  return { shipmentTeams, refetchShipmentTeams: GetShipmentTeams };
};

export default useFetchShipmentTeams;
